import React, { useState, useEffect } from "react";

export const StcStatusHeader = ({ lastUpdate }) => {
  const [relativeTime, setRelativeTime] = useState("");

  useEffect(() => {
    const computeRelative = () => {
      if (!lastUpdate) return "Loading...";
      const diffMs = Date.now() - new Date(lastUpdate).getTime();
      const diffMin = Math.floor(diffMs / 60000);
      if (diffMin < 1) return "Just now";
      if (diffMin < 60) return `${diffMin} min ago`;
      const diffHrs = Math.floor(diffMin / 60);
      if (diffHrs < 24) return `${diffHrs}h ${diffMin % 60}m ago`;
      const diffDays = Math.floor(diffHrs / 24);
      return `${diffDays}d ${diffHrs % 24}h ago`;
    };
    setRelativeTime(computeRelative());
    const interval = setInterval(() => setRelativeTime(computeRelative()), 60000);
    return () => clearInterval(interval);
  }, [lastUpdate]);

  const diffMs = lastUpdate ? Date.now() - new Date(lastUpdate).getTime() : 0;
  const statusColor = !lastUpdate
    ? "#888"
    : diffMs > 1800000
    ? "#ff4444"
    : diffMs > 600000
    ? "#ffaa00"
    : "#44ff44";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        padding: "8px 16px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: statusColor,
        }}
      />
      <span style={{ color: "#ccc", fontSize: 14 }}>
        Last reading: {relativeTime}
      </span>
    </div>
  );
};
